import BaseApi from './BaseApi'

export default class MediaRequestApi extends BaseApi {
    async getMediaRequests (params = {
        skip: 0,
        take: 10,
        lastActionFrom: null,
        lastActionTo: null,
        videoTimeFrom: null,
        videoTimeTo: null,
        fleetIds: null,
        createdBy: null,
        state: null,
        registrationNumber: null,
        hardwareId: null,
        loadMiniatures: false,
        driverId: null
    }) {
        const request = new URLSearchParams();

        if (params.skip) {
            request.append('Skip', params.skip);
        }

        if (params.take) {
            request.append('Take', params.take);
        }

        if (params.lastActionFrom) {
            request.append('LastActionFrom', params.lastActionFrom);
        }

        if (params.lastActionTo) {
            request.append('LastActionTo', params.lastActionTo);
        }

        // if (params.fleetIds) {
        //     params.fleetIds.forEach((item) => {
        //         request.append('FleetIds', item);
        //     })
        // }
        if (params.fleetIds) {
            request.append('FleetIds', params.fleetIds);
        }

        if (params.createdBy) {
            request.append('CreatedBy', params.createdBy);
        }

        if (params.videoTimeFrom) {
            request.append('VideoTimeFrom', params.videoTimeFrom);
        }

        if (params.videoTimeTo) {
            request.append('VideoTimeTo', params.videoTimeTo);
        }

        if (params.state) {
            request.append('State', params.state);
        }

        if (params.registrationNumber) {
            request.append('RegistrationNumber', params.registrationNumber);
        }

        if (params.hardwareId) {
            request.append('HardwareId', params.hardwareId);
        }

        if (params.loadMiniatures) {
            request.append('LoadMiniatures', params.loadMiniatures);
        }

        if (params.driverId) {
            request.append('DriverId', params.driverId);
        }

        return await this.get(`/api/v1.0/mediaRequests`, request)
    }
    async getMediaTotal () {
        return await this.get(`/api/v1.0/mediaRequests/total`);
    }
    async setMediaAsViewed (mediaId) {
        return await this.put('/api/v1.0/mediaRequests/setViewed', {
            mediaRequestId: mediaId
        })
    }
}
